import React from "react";
import LandingStyles from "./LandingStyles";
import ServiceDropdown from "./ServiceDropdown";
import { industries, locations, services, whyCards } from "./data";

function TextSection({ id, title, paragraphs }) {
  return (
    <section id={id} className="section" style={{ scrollMarginTop: 80 }}>
      <h2 style={{ color: "#0d47a1", fontSize: "2rem", marginBottom: 18 }}>
        {title}
      </h2>
      {paragraphs.map((paragraph) => (
        <p
          key={paragraph}
          style={{ color: "#263238", fontSize: "1.08rem", lineHeight: 1.7 }}
        >
          {paragraph}
        </p>
      ))}
    </section>
  );
}

function ListSection({ id, title, items, boxed = false }) {
  return (
    <section
      id={id}
      className={`section tag-section${boxed ? " section-bg" : ""}`}
      style={{ scrollMarginTop: 80 }}
    >
      <h2 style={{ color: "#0d47a1", fontSize: "1.5rem", marginBottom: 14 }}>
        {title}
      </h2>
      <ul className="tag-list">
        {items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </section>
  );
}

function ServicesSection() {
  return (
    <section id="services" className="section" style={{ scrollMarginTop: 80 }}>
      <h2 style={{ color: "#0d47a1", fontSize: "2rem", marginBottom: 18 }}>
        Our Global Business Solutions
      </h2>
      <div className="services-grid">
      {services.map((service) => (
        <ServiceDropdown key={service.title} title={service.title} lead={service.paragraphs[0]}>
          {service.paragraphs.map((paragraph) => (
            <p key={paragraph}>{paragraph}</p>
          ))}
          {service.groups.map((group) => (
            <div key={group.heading}>
              <h4 style={{ color: "#0d47a1", marginTop: 16 }}>{group.heading}</h4>
              {group.items?.map((item) => (
                <div key={item.label}>
                  <p>
                    <strong>{item.label}</strong>
                  </p>
                  <ul className="sub-list">
                    {item.bullets.map((bullet) => (
                      <li key={bullet}>{bullet}</li>
                    ))}
                  </ul>
                </div>
              ))}
              {group.standaloneBullets && (
                <ul className="sub-list">
                  {group.standaloneBullets.map((bullet) => (
                    <li key={bullet}>{bullet}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
          {service.footerNote && (
            <p style={{ fontStyle: "italic", color: "#37474f", marginTop: 14 }}>
              {service.footerNote}
            </p>
          )}
        </ServiceDropdown>
      ))}
      </div>
    </section>
  );
}

const featureIcons = ["↗", "◎", "◌", "✦", "↔", "✓", "◈", "⌁", "→"];

function WhySection() {
  return (
    <section id="why" className="section" style={{ scrollMarginTop: 80 }}>
      <h2 style={{ color: "#0d47a1", fontSize: "2rem", marginBottom: 10 }}>
        Why Companies Partner with Kansasroot
      </h2>
      <p style={{ color: "#263238", fontSize: "1.08rem", lineHeight: 1.7 }}>
        At Kansasroot, we go beyond traditional outsourcing-we become a strategic
        partner focused on driving efficiency, scalability, and long-term
        business growth. Our client-first approach, combined with global
        expertise and cost-effective delivery from India, makes us a trusted
        choice for organizations worldwide.
      </p>
      <h3 style={{ color: "#0d47a1", marginTop: 24, marginBottom: 10 }}>
        What Sets Us Apart
      </h3>
      <div className="why-grid">
        {whyCards.map((card, index) => (
          <div
            key={card.title}
            className="why-card"
          >
            <span className="why-card-icon" aria-hidden="true">{featureIcons[index]}</span>
            <h4>{card.title}</h4>
            <p>{card.description}</p>
          </div>
        ))}
      </div>
      <blockquote
        className="partnership-quote"
        style={{
          borderLeft: "4px solid #0d47a1",
          paddingLeft: 18,
          margin: "28px 0 0",
          fontStyle: "italic",
          color: "#1a237e",
          fontSize: "1.12rem",
          lineHeight: 1.7,
        }}
      >
        "Partnering with Kansasroot means gaining a reliable, scalable, and
        results-driven extension of your business."
      </blockquote>
    </section>
  );
}

function LandingPage({
  menuOpen,
  showScroll,
  onToggleMenu,
  onShowAuthModal,
  onCloseMenu,
}) {
  return (
    <div
      style={{
        fontFamily: "Segoe UI, Arial, sans-serif",
        background: "#f5f7fa",
        color: "#1a237e",
        minHeight: "100vh",
        padding: 0,
        margin: 0,
      }}
    >
      <LandingStyles />

      <nav className={`nav${showScroll ? " scrolled" : ""}`}>
        <div className="nav-inner">
          <a
            href="#hero"
            className="nav-brand"
            onClick={onCloseMenu}
          >
            <span className="nav-wordmark">KANSASROOT</span>
            <span className="nav-tagline">Your Partner in Success</span>
          </a>
          <div className="nav-menu">
            <ul className={menuOpen ? "open" : ""}>
              <li><a className="nav-link" href="#hero" onClick={onCloseMenu}>Home</a></li>
              <li><a className="nav-link" href="#about" onClick={onCloseMenu}>About Us</a></li>
              <li><a className="nav-link" href="#services" onClick={onCloseMenu}>Service</a></li>
              <li><a className="nav-link" href="#industries" onClick={onCloseMenu}>Industries we serve</a></li>
              <li><a className="nav-link" href="#why" onClick={onCloseMenu}>Why Kansasroot</a></li>
              <li><a className="nav-link" href="#contact" onClick={onCloseMenu}>Contact</a></li>
            </ul>
          </div>
          <div className="nav-actions">
            <a className="nav-quote" href="#contact" onClick={onCloseMenu}>
              Get a Quote
            </a>
            <button className="hamburger" onClick={onToggleMenu} aria-label="Toggle navigation menu" aria-expanded={menuOpen}>
              &#9776;
            </button>
            <button
              className="auth-icon"
              onClick={onShowAuthModal}
              title="Login / Signup"
              aria-label="Login or sign up"
            >
              &#128100;
            </button>
          </div>
        </div>
      </nav>

      <section id="hero" className="hero" style={{ scrollMarginTop: 80 }}>
        <div className="hero-orbit hero-orbit-one" aria-hidden="true" />
        <div className="hero-orbit hero-orbit-two" aria-hidden="true" />
        <div className="hero-content">
          <div className="hero-eyebrow">
            <span>KANSASROOT</span>
            <span>Your Partner in Success</span>
          </div>
          <h1>Build Your Global Team Without Increasing Payroll Costs</h1>
          <p>
            Kansasroot empowers global businesses across the US, UK, EU & APAC to
            scale rapidly through expert recruitment, accounting outsourcing,
            Digital Marketing, BPO services, and workforce solutions-powered by
            India.
          </p>
          <div className="hero-actions">
            <button
              type="button"
              className="hero-cta hero-cta-primary"
              onClick={() =>
                document
                  .getElementById("careers")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
            >
              Job Form
            </button>
            <button
              type="button"
              className="hero-cta hero-cta-secondary"
              onClick={() =>
                document
                  .getElementById("careers")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
            >
              Explore Careers
            </button>
            <button
              type="button"
              className="hero-cta hero-cta-secondary"
              onClick={() =>
                document
                  .getElementById("contact")
                  ?.scrollIntoView({ behavior: "smooth" })
              }
            >
              Start a Partnership
            </button>
          </div>
        </div>
        <a className="hero-scroll-cue" href="#about" aria-label="Scroll to About Us">
          <span>Scroll to explore</span>
          <span aria-hidden="true">↓</span>
        </a>
      </section>

      <main
        className="main"
        style={{
          maxWidth: 960,
          margin: "0 auto",
          padding: "2rem",
          scrollBehavior: "smooth",
        }}
      >
        <TextSection
          id="about"
          title="About Us"
          paragraphs={[
            "Kansasroot empowers global businesses with scalable outsourcing solutions designed for growth. Serving clients across Europe, the United States, UK, Dubai, India and rest APAC country, we specialize in recruitment, BPO services, accounting outsourcing, Digital marketing and tech-enabled HR solutions.",
            "We help organizations simplify operations, optimize costs, and access top talent-while maintaining high standards of quality and performance. Our approach blends human expertise with automation to ensure faster, smarter, and more efficient outcomes.",
            "From startups to large enterprises, Kansasroot acts as a strategic partner, delivering solutions that drive productivity and long-term success.",
          ]}
        />

        <ServicesSection />
        <ListSection id="industries" title="Industries We Serve" items={industries} />
        <ListSection title="Locations We Serve" items={locations} boxed />
        <WhySection />

        <section
          id="careers"
          className="section section-bg careers-panel"
          style={{ scrollMarginTop: 80 }}
        >
          <div className="careers-copy">
            <h2 style={{ color: "#0d47a1", fontSize: "2rem", marginBottom: 12 }}>
              Careers
            </h2>
            <p style={{ color: "#263238", fontSize: "1.05rem", lineHeight: 1.7 }}>
              Join Kansasroot and build your career across recruitment,
              accounting, digital marketing, BPO, and technology services.
              We&apos;re always looking for motivated professionals who want to
              grow with a fast-moving global team.
            </p>
          </div>
          <div className="careers-action">
            <a
              href="mailto:info@kansasroot.com?subject=Job%20Application%20-%20Kansasroot"
            >
              Open Job Form
            </a>
          </div>
        </section>

        <section
          id="contact"
          className="contact cta-banner"
          style={{ scrollMarginTop: 80, textAlign: "center", margin: "48px 0 0" }}
        >
          <div className="cta-banner-content">
            <h2 style={{ color: "#0d47a1", marginBottom: 12 }}>
              Book a consultation to explore how Kansasroot can support your
              organization.
            </h2>
            <div style={{ marginTop: 16, color: "#263238", fontSize: "0.98rem" }}>
              Email: info@kansasroot.com
            </div>
          </div>
          <a href="mailto:info@kansasroot.com">Contact Us</a>
        </section>
      </main>

      <footer className="footer">
        <div className="footer-main">
          <div className="footer-brand">
            <a href="#hero" onClick={onCloseMenu}>KANSASROOT</a>
            <p>Your Partner in Success</p>
          </div>
          <div className="footer-column">
            <h2>Quick Links</h2>
            <ul>
              <li><a href="#hero" onClick={onCloseMenu}>Home</a></li>
              <li><a href="#about" onClick={onCloseMenu}>About Us</a></li>
              <li><a href="#services" onClick={onCloseMenu}>Service</a></li>
              <li><a href="#industries" onClick={onCloseMenu}>Industries we serve</a></li>
              <li><a href="#why" onClick={onCloseMenu}>Why Kansasroot</a></li>
              <li><a href="#contact" onClick={onCloseMenu}>Contact</a></li>
            </ul>
          </div>
          <div className="footer-column">
            <h2>Services</h2>
            <ul>
              <li>Recruitment &amp; Talent Acquisition</li>
              <li>Accounting Services</li>
              <li>Digital Marketing</li>
              <li>Back-office &amp; Support</li>
              <li>Software Services</li>
            </ul>
          </div>
          <div className="footer-column footer-contact">
            <h2>Contact</h2>
            <a href="mailto:info@kansasroot.com">info@kansasroot.com</a>
          </div>
        </div>
        <div className="footer-bottom">
          <small>© 2026 Kansasroot. All rights reserved.</small>
        </div>
      </footer>

      <button
        className={`scroll-to-top ${showScroll ? "show" : ""}`}
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        &#8593;
      </button>
    </div>
  );
}

export default LandingPage;
